import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { formatDate } from '../../lib/utils/time';
import { getSettings } from '../../lib/stores/settings.svelte.ts';
import { gramsToLbs } from '../../lib/utils/units.ts';

var root_2 = $.from_svg(`<line stroke="var(--border)" stroke-width="0.5"></line>`);
var root_3 = $.from_svg(`<path fill="none" stroke="var(--primary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>`);
var root_4 = $.from_svg(`<circle r="4" fill="var(--primary)"></circle>`);
var root_1 = $.from_svg(`<svg class="growth-chart svelte-3c2pemetqv3yt"><!><!><!><text text-anchor="end" class="axis-label svelte-3c2pemetqv3yt"> </text><text text-anchor="end" class="axis-label svelte-3c2pemetqv3yt"> </text></svg>`);
var root_5 = $.from_html(`<p class="no-data svelte-3c2pemetqv3yt">No weight data yet</p>`);

function GrowthChart($$anchor, $$props) {
	$.push($$props, true);

	const settings = $.derived(getSettings);
	const isImperial = $.derived(() => $.get(settings).units === 'imperial');
	const width = 320;
	const height = 180;
	const padding = { top: 20, right: 20, bottom: 30, left: 45 };
	const chartW = $.derived(() => width - padding.left - padding.right);
	const chartH = $.derived(() => height - padding.top - padding.bottom);

	const minWeight = $.derived(() => $$props.weights.length
		? Math.min(...$$props.weights.map((w) => w.weightGrams)) * 0.95
		: 0);

	const maxWeight = $.derived(() => $$props.weights.length
		? Math.max(...$$props.weights.map((w) => w.weightGrams)) * 1.05
		: 1);

	const minDate = $.derived(() => $$props.weights.length ? Math.min(...$$props.weights.map((w) => w.date)) : 0);
	const maxDate = $.derived(() => $$props.weights.length ? Math.max(...$$props.weights.map((w) => w.date)) : 1);

	function x(date) {
		if ($.get(maxDate) === $.get(minDate)) return $.get(chartW) / 2;

		return (date - $.get(minDate)) / ($.get(maxDate) - $.get(minDate)) * $.get(chartW);
	}

	function y(grams) {
		return $.get(chartH) - (grams - $.get(minWeight)) / ($.get(maxWeight) - $.get(minWeight)) * $.get(chartH);
	}

	const linePath = $.derived(() => () => {
		if ($$props.weights.length < 2) return '';

		return $$props.weights.map((w, i) => `${i === 0 ? 'M' : 'L'} ${padding.left + x(w.date)} ${padding.top + y(w.weightGrams)}`).join(' ');
	});

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_1 = ($$anchor) => {
			var svg = root_1();

			$.set_attribute(svg, 'viewBox', '0 0 320 180');

			var node_1 = $.child(svg);

			$.each(node_1, 16, () => [0.25, 0.5, 0.75], $.index, ($$anchor, frac) => {
				var line = root_2();

				$.template_effect(() => {
					$.set_attribute(line, 'x1', padding.left);
					$.set_attribute(line, 'y1', padding.top + $.get(chartH) * frac);
					$.set_attribute(line, 'x2', padding.left + $.get(chartW));
					$.set_attribute(line, 'y2', padding.top + $.get(chartH) * frac);
				});

				$.append($$anchor, line);
			});

			var node_2 = $.sibling(node_1);

			{
				var consequent = ($$anchor) => {
					var path = root_3();

					$.template_effect(($0) => $.set_attribute(path, 'd', $0), [() => $.get(linePath)()]);
					$.append($$anchor, path);
				};

				$.if(node_2, ($$render) => {
					if ($$props.weights.length >= 2) $$render(consequent);
				});
			}

			var node_3 = $.sibling(node_2);

			$.each(node_3, 17, () => $$props.weights, $.index, ($$anchor, w) => {
				var circle = root_4();

				$.template_effect(
					($0, $1) => {
						$.set_attribute(circle, 'cx', $0);
						$.set_attribute(circle, 'cy', $1);
					},
					[
						() => padding.left + x($.get(w).date),
						() => padding.top + y($.get(w).weightGrams)
					]
				);

				$.append($$anchor, circle);
			});

			var text = $.sibling(node_3);
			var text_1 = $.child(text, true);

			$.reset(text);

			var text_2 = $.sibling(text);
			var text_3 = $.child(text_2, true);

			$.reset(text_2);
			$.reset(svg);

			$.template_effect(
				($0, $1) => {
					$.set_attribute(text, 'x', padding.left - 8);
					$.set_attribute(text, 'y', padding.top + 4);
					$.set_text(text_1, $0);
					$.set_attribute(text_2, 'x', padding.left - 8);
					$.set_attribute(text_2, 'y', padding.top + $.get(chartH) + 4);
					$.set_text(text_3, $1);
				},
				[
					() => $.get(isImperial)
						? gramsToLbs($.get(maxWeight)) + 'lbs'
						: Math.round($.get(maxWeight)) + 'g',

					() => $.get(isImperial)
						? gramsToLbs($.get(minWeight)) + 'lbs'
						: Math.round($.get(minWeight)) + 'g'
				]
			);

			$.append($$anchor, svg);
		};

		var alternate = ($$anchor) => {
			var p = root_5();

			$.append($$anchor, p);
		};

		$.if(node, ($$render) => {
			if ($$props.weights.length > 0) $$render(consequent_1); else $$render(alternate, -1);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	GrowthChart = $.hmr(GrowthChart);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-3c2pemetqv3yt');
		GrowthChart[$.HMR].update(module.default);
	});
}

export default GrowthChart;
import "bun-svelte:GrowthChart.svelte-ub60987ez6i1-style.css";